import { FacadeService } from "src/app/shared/service-facade/facade.service";
import { SuggestedAddressRules } from "./suggested-address-rules.abstract";
import { DefaultRulesService } from "./default-rules.service"
import { BaskRulesService } from "./bask-rules.service"

export function SuggestedAddressRulesFactory(facade: FacadeService): SuggestedAddressRules {
  if (facade.isBaskBrand()) {
    return new BaskRulesService();
  }

  return new DefaultRulesService();
}
